module.exports = __webpack_public_path__ + "img/geren.b2beaee0.png";